<div class="row">
  <div class="columns">
    <h4 class="mos-u-display--inline-block mos-u-spacer--margin-top-sm">
      Notification Settings
    </h4>
  </div>
</div>
<div class="row">
  <div class="columns medium-8">
    <div class="row mos-u-divider--bottom-md">
      <div class="columns medium-3 dsp-notification-item dsp-notification-header">
        <strong>Item Alerts</strong>
      </div>
      <div class="columns medium-4 dsp-notification-center-vertical dsp-notification-header">
        <span>Options</span>
      </div>
      <div class="columns medium-2 dsp-notification-center dsp-notification-header">
        <span>Email</span>
      </div>
      <div class="columns medium-3 dsp-notification-center dsp-notification-header">
        <span>Notifications on Portal</span>
      </div>
    </div>
    <div class="row">
      <div class="columns medium-3 dsp-notification-item">
        <span>Transactions</span>
      </div>
      <div class="columns medium-4 mos-u-spacer--padding-sm dsp-notification-select-col">
        <atlas-field-select [style.--radius-xsmall]="'4px'" [size]="sizeSmall" [widthValue]="200" [clearable]="false"
          id="transactions-select-input" placeholder="Select" [multiselectable]="true" [options]="transactionsOptions"
          [showSelectAll]="true" [checkbox]="true" (valueChange)="onChangeOptions('transactions', $event)"
          [(ngModel)]="transactions.options" [disabled]="false">
        </atlas-field-select>
      </div>
      <div class="columns medium-2 dsp-notification-center">
        <atlas-switch [color]="'brand'" [(ngModel)]="transactions.email"></atlas-switch>
      </div>
      <div class="columns medium-3 dsp-notification-center">
        <atlas-switch [color]="'brand'" [(ngModel)]="transactions.portal"></atlas-switch>
      </div>
    </div>
    <div class="row">
      <div class="columns medium-3 dsp-notification-item">
        <span>Statements</span>
      </div>
      <div class="columns medium-3 mos-u-spacer--padding-sm dsp-notification-select-col">
        <atlas-field-select [style.--radius-xsmall]="'4px'" [size]="sizeSmall" [widthValue]="200" [clearable]="false"
          id="statements-select-input" placeholder="Select" [multiselectable]="true" [options]="statementsOptions"
          [showSelectAll]="true" [checkbox]="true" (valueChange)="onChangeOptions('statements', $event)"
          [(ngModel)]="statements.options" [disabled]="false">
        </atlas-field-select>
      </div>
      <div class="columns medium-2 dsp-notification-center">
        <atlas-switch [color]="'brand'" [(ngModel)]="statements.email"></atlas-switch>
      </div>
      <div class="columns medium-3 dsp-notification-center">
        <atlas-switch [color]="'brand'" [(ngModel)]="statements.portal"></atlas-switch>
      </div>
    </div>
    <div class="row">
      <div class="columns medium-3 dsp-notification-item">
        <span>Documents</span>
      </div>
      <div class="columns medium-3 mos-u-spacer--padding-sm dsp-notification-select-col">

        <atlas-field-select [style.--radius-xsmall]="'4px'" [size]="sizeSmall" [widthValue]="200" [clearable]="false"
          id="documents-select-input" placeholder="Select" [multiselectable]="true" [options]="documentsOptions"
          [showSelectAll]="true" [checkbox]="true" (valueChange)="onChangeOptions('documents', $event)"
          [(ngModel)]="documents.options" [disabled]="false">
        </atlas-field-select>
      </div>
      <div class="columns medium-2 dsp-notification-center">
        <atlas-switch [color]="'brand'" [(ngModel)]="documents.email"></atlas-switch>
      </div>
      <div class="columns medium-3 dsp-notification-center">
        <atlas-switch [color]="'brand'" [(ngModel)]="documents.portal"></atlas-switch>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="columns table-data-footer__align-right shrink">
    <atlas-button id="button-notifications-save" [style]="'strong'" (click)="onSave()">
      Save
    </atlas-button>
    <atlas-button id="button-notifications-cancel" variant="text" (click)="onCancel()">
      Cancel
    </atlas-button>
  </div>
</div>